import { useQuery } from "@tanstack/react-query";
import { fetchUser } from "PFCore/services/admin/users/fetch_user";

import { adminKeys } from "./query_keys";

export const useUser = (id: string) =>
  useQuery({ queryKey: adminKeys.user(id), queryFn: () => fetchUser(id) });
